import { gql } from '@apollo/client';
import {
  ErrorMessageInfo,
  SubscriptionInfoShared,
} from '@retainerclub/shared-api';

export default gql`
  mutation actionSubscriptionAdminPause($input: SubscriptionPauseActionInput!) {
    actionSubscriptionAdminPause(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      previewData
      subscription {
        ...SubscriptionInfoShared
      }
    }
  }
  ${ErrorMessageInfo}
  ${SubscriptionInfoShared}
`;
